export const FOLLOW_REQUEST = 'FOLLOW_REQUEST'
export const FOLLOWS = 'FOLLOWS'
